import React from 'react'
import {
  Edit,
  SimpleForm,
  TextInput,
  NumberInput,
  FormDataConsumer,
  required,
} from 'react-admin'
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  makeStyles,
} from '@material-ui/core'
import Toolbar from '../../components/FormToolbar'
import { POINT_FIELDS } from '../../utils/points'

const useStyles = makeStyles({
  root: {
    width: 360, // ограничиваем ширину всей таблицы
    marginTop: 12,
  },
  title: {
    fontSize: 14,
    fontWeight: 600,
    marginBottom: 4,
  },
  hint: {
    fontSize: 12,
    color: '#666',
    marginBottom: 8,
  },
  cell: {
    padding: '2px 8px', // компактные отступы
    fontSize: 13,
  },
  numberCell: {
    padding: '2px 8px',
    width: 110,
  },
  numberInput: {
    width: 90,
  },
})

const RatingPointsInputs = ({ formData }) => {
  const classes = useStyles()
  const ratingPoints = formData?.rating_points || []

  const findIndex = (place, without_fights) =>
    ratingPoints.findIndex(
      (p) =>
        Boolean(p.without_fights) === Boolean(without_fights) &&
        (without_fights || Number(p.place) === Number(place))
    )

  const rows = POINT_FIELDS.map(({ place, label }) => {
    const idx = findIndex(place, false)
    if (idx < 0) return null
    return { key: `p-${place}`, label, source: `rating_points[${idx}].points` }
  }).filter(Boolean)

  const withoutFightsIdx = findIndex(1, true)
  if (withoutFightsIdx >= 0) {
    rows.push({
      key: 'p-without-fights',
      label: '1-е место без боя',
      source: `rating_points[${withoutFightsIdx}].points`,
    })
  }

  return (
    <div className={classes.root}>
      <Typography className={classes.title}>Баллы за призовые места</Typography>
      <Typography className={classes.hint}>
        Места и признак «без боя» изменить нельзя.
      </Typography>

      <TableContainer component={Paper} variant='outlined'>
        <Table size='small'>
          <TableHead>
            <TableRow>
              <TableCell className={classes.cell}>Место</TableCell>
              <TableCell className={classes.cell} align='right'>
                Баллы
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow key={row.key}>
                <TableCell className={classes.cell} component='th' scope='row'>
                  {row.label}
                </TableCell>
                <TableCell className={classes.numberCell} align='right'>
                  <NumberInput
                    source={row.source}
                    label=''
                    min={0}
                    margin='dense'
                    variant='outlined'
                    className={classes.numberInput}
                    style={{ width: 90 }}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  )
}

const transform = (data) => {
  const ratingPoints = (data.rating_points || []).map((point) => ({
    id: point.id,
    points: Number(point.points) || 0,
  }))

  return {
    tournament_level_id: data.tournament_level_id || data.id,
    tournament_level_title: data.tournament_level_title,
    rating_points: ratingPoints,
  }
}

const EditTournamentLevel = (props) => (
  <Edit
    {...props}
    title='Редактирование уровня турнира'
    undoable={false}
    transform={transform}
  >
    <SimpleForm toolbar={<Toolbar />}>
      <TextInput
        source='tournament_level_title'
        label='Название уровня турнира'
        validate={required()}
        fullWidth
      />
      <FormDataConsumer>
        {({ formData, ...rest }) => (
          <RatingPointsInputs formData={formData} {...rest} />
        )}
      </FormDataConsumer>
    </SimpleForm>
  </Edit>
)

export default EditTournamentLevel
